import { createStrategy, updateStrategy } from './strategies';
import { ActionType, type Action, type ContentBlock } from './types';
import {
  ResourceTypes,
  type ResourceGroupContent,
  type TextContent,
} from '@/data/learning-path/interfaces';

export const reducer = (
  state: ContentBlock[],
  action: Action
): ContentBlock[] => {
  switch (action.type) {
    case ActionType.AddBlock: {
      const position = state.length;
      const type = action.payload.type;

      const create = createStrategy[type];
      if (!create) return state;

      return [...state, create(position)];
    }
    case ActionType.UpdateBlock: {
      return state.map((block) => {
        if (block.id !== action.payload.id) return block;

        if (block.type === ResourceTypes.Text) {
          return updateStrategy[ResourceTypes.Text](
            block,
            action.payload.data as Partial<TextContent>
          );
        }

        if (block.type === ResourceTypes.ResourceGroup) {
          return updateStrategy[ResourceTypes.ResourceGroup](
            block,
            action.payload.data as Partial<ResourceGroupContent>
          );
        }

        return block;
      });
    }
    case ActionType.RemoveBlock: {
      return state
        .filter((block) => block.id !== action.payload.id)
        .map((block, i) => ({ ...block, position: i }));
    }
    case ActionType.ReorderBlocks: {
      return action.payload.map((block, i) => ({
        ...block,
        position: i,
      }));
    }
    default:
      return state;
  }
};
